import React, { useState, useContext, useEffect } from 'react';
import ViewsContext from 'contexts/viewsContext';
import CategorySalesChartGlance from './categorySalesChartGlance';
import CategorySalesTableViewGlance from './categorySalesTableViewGlance';


export default function ToggleCategorySalesGlance(props) {

    const { viewsState, setCategorySalesToggleState } = useContext(ViewsContext);
    const [chartToggleClass, setChartToggleClass] = useState('');
    const [tableViewToggleClass, setTableViewToggleClass] = useState('');

    useEffect(() => {
        if (viewsState.chartsAndTableViewsConfigs.categorySalesToggleState === 'chart') {
            setTableViewToggleClass('togglable-hidden');
            setChartToggleClass('');
        }
        else if (viewsState.chartsAndTableViewsConfigs.categorySalesToggleState === 'tableView') {
            setChartToggleClass('togglable-hidden');
            setTableViewToggleClass('');
        }

    }, [viewsState]);

    const changeView = () => {
        if (viewsState.chartsAndTableViewsConfigs.categorySalesToggleState === 'chart') {
            setCategorySalesToggleState('tableView');
        }
        else if (viewsState.chartsAndTableViewsConfigs.categorySalesToggleState === 'tableView') {
            setCategorySalesToggleState('chart');
        }
    };

    if (viewsState.chartsAndTableViewsConfigs.categorySalesToggleState === 'chart') {
        return (
            <>
                <div className='glance-holder col-12  col-md-6'>
                    <CategorySalesChartGlance data={props.data} viewState={chartToggleClass} changeViewStateFn={changeView} />
                </div>
            </>
        );
    }
    else {
        return (
            <>
                <div className='glance-holder col-12  col-md-6'>
                    <CategorySalesTableViewGlance data={props.data} viewState={tableViewToggleClass} changeViewStateFn={changeView} />
                </div>
            </>
        );
    }

}

